// Options for the observer (which mutations to observe)
const config = { attributes: true, childList: true, subtree: true };


// Callback function to execute when mutations are observed
const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
        if (mutation.type === "childList") {
            if (mutation.addedNodes.length > 0 && mutation.addedNodes[0].tagName === "INS" && mutation.addedNodes[0].classList.contains("desktop-ad")) {
                mutation.target.closest(".adserver-wrapper").classList.add("bg-white")
                observer.disconnect()
            }
            if (mutation.addedNodes.length > 0 && mutation.addedNodes[0].tagName === "SCRIPT" && !mutation.addedNodes[0].src.includes("asyncjs.php") && !mutation.addedNodes[0].src.includes("cookiebot")) {
                mutation.target.closest(".adserver-wrapper").remove();
                observer.disconnect()
            }
        }
    }
};

// Create an observer instance linked to the callback function
const observer = new MutationObserver(callback);

observeAdBanners()

function observeAdBanners() {
    document.querySelectorAll(".adserver-wrapper:has(.desktop-ad), .adserver-wrapper:has(.mobile-ad)").forEach(element => {
        observer.observe(element, config);
    })
}


